import React, { Component } from 'react';

class AdminPanel extends Component {
  render() {
    return (
      <div className="col-sm-6">
        <div className="well">
          <div className="row">
            <div className="col-sm-6">
              <h2>Administrator</h2>
              <a href="#applications-list">Applications</a> <br />
              <a href="#customers-list">Customers</a> <br />
              <a href="#logs">Logs</a> <br />
            </div>
            <div className="col-sm-6">
              <img
                className="home-icon"
                src="images/admin.png"
                alt="admin"
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AdminPanel


// WEBPACK FOOTER //
// ./src/Components/AdminPanel/AdminPanel.js